import Tr from 'translations/Translations';

export const OfferEvaluationPositionStatus = {
    ALLOWED: "ALLOWED",
    EXCLUDED: "EXCLUDED",
    EXTREMELY_LOW: "EXTREMELY_LOW",
    NOT_SCORED: "NOT_SCORED",
    OUT_OF_DATE: "OUT_OF_DATE",
    EXCLUDED_FROM_CONTRACT: "EXCLUDED_FROM_CONTRACT"
}
const _TR_PREFIX = 'offer_evaluation_position_status_';

export const OfferEvaluationPositionStatusLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));
